import React, { useEffect, useState } from 'react'
import { Project } from './Project'
import Tabletop from 'tabletop'
import snarkdown from 'snarkdown'
import { sanitize } from 'dompurify'

import { PreviousProjects } from 'components/previousProjects'
import { ProjectResult } from 'components/projectResult'

export function ProjectResults() {
  const [projects, setProjects] = useState<Project[]>([])

  useEffect(() => {
    fetch('https://interaktiv.tagesanzeiger.ch/2019/younews/Projekte.json')
      .then(response => response.json())
      .then(data => setProjects(Object.values(data)))
  }, [])

  return (
    <div className='ui vertical blue segment'>
      <div className='ui text container'>
        <h2 className='ui center aligned header'>Projekte</h2>

        {projects.map((project, index) => {
          return (
            <ProjectResult
              key={'project-' + index}
              {...project}
              Beschreibung={sanitize(snarkdown(project.Beschreibung))}
            />
          )
        })}

        <PreviousProjects />
      </div>
    </div>
  )
}
